export default class Recharge {
  constructor (data = {}) {
    this.ddd = data.ddd;
    this.number = data.number || null;
    this.operator = data.operator || null;
    this.amount = data.amount || null;
  }
}
